// extracted by mini-css-extract-plugin
export var actionButton = "_85-1";
export var actionButtons = "_85-2";
export var actions = "_85-0";
export var aiUnread = "_85-10";
export var alignCenter = "_85-h";
export var backWrapper = "_85-3";
export var cellContainer = "_85-4";
export var checkboxContainer = "_85-5";
export var contentContainer = "_85-6";
export var contentHeader = "_85-8";
export var conversationsTableWrapper = "_85-s";
export var draftReplyBadgeContainer = "_85-m";
export var dropdownItem = "_85-b";
export var dropdownItemsContainer = "_85-a";
export var dropdownTitle = "_85-c";
export var errorIcon = "_85-7";
export var filter = "_85-d";
export var gray = "_85-i";
export var headerActionButtons = "_85-e";
export var headerCheckboxContainer = "_85-f";
export var icon = "_85-j";
export var menuContainer = "_85-k";
export var noMoreTicketsIcon = "_85-12";
export var noMoreTicketsSubText = "_85-13";
export var oneLine = "_85-l";
export var optionsButton = "_85-n";
export var plus = "_85-o";
export var portalButtonsWrapper = "_85-g";
export var red = "_85-p";
export var scrolledTop = "_85-9";
export var search = "_85-q";
export var selectedConversationsCount = "_85-r";
export var spinner = "_85-t";
export var strong = "_85-u";
export var summaryCell = "_85-v";
export var tableContainer = "_85-11";
export var tagContainer = "_85-w";
export var threeDots = "_85-x";
export var twoLines = "_85-y";
export var unread = "_85-z";